import * as React from 'react';
import { Children, isValidElement, cloneElement, ComponentPropsWithoutRef } from 'react';
import clsx from 'clsx';
import { IGIInputProps } from './GIInput';

type GIFormControlPropsPicked = 'className' | 'children';

interface IGIFormControlProps
  extends Pick<ComponentPropsWithoutRef<'div'>, GIFormControlPropsPicked>,
    Pick<IGIInputProps, 'name' | 'required' | 'type' | 'onChange'> {
  id: string;
}

interface IGIFormControlChildProps extends Pick<IGIInputProps, 'name' | 'required' | 'type' | 'onChange'> {}

export const GIFormControl = ({ id, className, children, name, required, type = 'text' }: IGIFormControlProps) => {
  return (
    <div id={id} className={clsx('gi-component', `gi-${type}`, className)}>
      {Children.map(children, child => {
        if (isValidElement<IGIFormControlChildProps>(child)) {
          return cloneElement<IGIFormControlChildProps>(child, {
              name,
              required,
              type
          });
        }
        return child;
      })}
    </div>
  );
};